import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=a73a423a&scoped=true&"
import script from "./PermissionList.vue?vue&type=script&lang=js&"
export * from "./PermissionList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=a73a423a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73a423a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a73a423a')) {
      api.createRecord('a73a423a', component.options)
    } else {
      api.reload('a73a423a', component.options)
    }
    module.hot.accept("./PermissionList.vue?vue&type=template&id=a73a423a&scoped=true&", function () {
      api.rerender('a73a423a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/PermissionList.vue"
export default component.exports